<script>

import { Pie } from 'vue-chartjs';

export default {
  name: 'PieChart',
  extends: Pie,
  props: {
    chartId: {
      type: String,
      default: 'pie-chart',
    },
    title: {
      type: String,
      required: false,
      default: 'Custom Chart Title',
    },
    data: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: 'number',
    },
    backgroundColours: {
      type: Array,
      required: false,
      default: () => ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 300,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    legendIsClickable: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    const self = this;

    return {
      chartData: {
        labels: this.data.labels || [],
        datasets: [
          {
            backgroundColor: this.backgroundColours,
            data: this.data.values || [],
          },
        ],
      },
      chartOptions: {
        responsive: true,
        legend: {
          position: 'right',
          align: 'start',
          ...(this.legendIsClickable ? {} : { onClick: null }),
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => data.labels[tooltipItem.index] || '',
            afterLabel: (tooltipItem, data) => {
              const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              return self.type === 'percentage' ? `${value.toFixed(2)}%` : `${value.toLocaleString()}`;
            },
          },
        },
        maintainAspectRatio: false,
      },
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  },
  watch: {
    data: {
      handler(newData) {
        if (this.$data._chart) {
          this.$data._chart.data.labels = newData.labels;
          this.$data._chart.data.datasets[0].data = newData.values;
          this.$data._chart.update();
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
